import { PopoverContent as AkPopoverContent, type PopoverContentProps } from '@atlaskit/spotlight';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ToggleableChoreographerUtilities,
} from '../../types';
import { wrapToggleableComponentForChoreographer } from '../utils';

export const PopoverContent: {
	({
		shouldBeChoreographed,
		withChoreographedToggle,
		...props
	}: (PopoverContentProps & ToggleableChoreographerUtilities) &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapToggleableComponentForChoreographer<PopoverContentProps>(AkPopoverContent, 'isVisible');
